import React, { useState, useEffect } from 'react';
import { LuChevronRight, LuChevronDown } from "react-icons/lu"; 
import "../../asset/css/register.css";
import { baseurl } from '../../baseurl';
import axios from 'axios';
import Swal from 'sweetalert2';
import logo from "../../asset/img/white.png";

const Register = () => {
  // 1. State for form data - added referralCode
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    companyName: '',
    password: '',
    source: '',
    referralCode: '', // Captured from URL
    agreeTerms: false,
    marketingEmails: false
  });

  // 2. Capture referral code from URL on component mount
  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const ref = queryParams.get('ref');
    if (ref) {
      setFormData(prev => ({
        ...prev,
        referralCode: ref
      }));
    }
  }, []);

  // 3. SweetAlert Toast Configuration
  const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.addEventListener('mouseenter', Swal.stopTimer);
      toast.addEventListener('mouseleave', Swal.resumeTimer);
    }
  });

  // 4. Handle Input Changes
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  // 5. Handle Form Submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    try {
      // formData now includes the referralCode if it was in the URL
      const response = await axios.post(`${baseurl}registerUser`, formData);
      
      if (response.status === 200 || response.status === 201) {
        const userData = response.data.data;
        const expiryTime = new Date().getTime() + 172800000; 
        
        const storageItem = {
          userInfo: userData,
          expiry: expiryTime
        };

        localStorage.setItem('user_session', JSON.stringify(storageItem));

        Toast.fire({
          icon: 'success',
          title: 'Account created successfully!'
        });

        setTimeout(() => window.location.href = '/plan-detail', 1500);
      }
    } catch (error) {
      console.error("Registration Error:", error);
      Toast.fire({
        icon: 'error',
        title: error.response?.data?.message || 'Registration failed.'
      });
    }
  };

  const validatePassword = (pass) => {
    return {
      minLength: pass.length >= 8,
      hasUppercase: /[A-Z]/.test(pass),
      hasNumber: /[0-9]/.test(pass),
    };
  }; 
  const checks = validatePassword(formData.password);

  return (
    <div className="register-wrapper">
      <nav className="reg-nav">
        <div className="reg-logo">
          <div>
      <img src={logo} className='img-fluid' style={{maxHeight:"40px",}} />
    {/* <div className="sub-brand  text-dark">Project Management Dashboard</div> */}
    </div>
        </div>
        <div className="login-link">
          Already have an account? <a href="/login">Log in</a>
        </div>
      </nav>

      <div className="reg-container">
        <div className="stepper">
          <div className="step-item active">
            <div className="step-circle">1</div>
            <span className="step-label">Create Account</span>
          </div>
          <div className="step-line"></div>
          <div className="step-item inactive">
            <div className="step-circle">2</div>
            <span className="step-label">Choose Plan</span>
          </div>
        </div>

        <div className="reg-card">
          <header className="reg-header">
            <h1>Create Your Measro Account</h1>
            {/* Visual indicator for referral */}
            {formData.referralCode && (
              <div className="referral-alert" style={{
                background: '#eef2ff',
                color: '#6366f1',
                padding: '10px',
                borderRadius: '8px',
                fontSize: '14px',
                marginBottom: '15px',
                fontWeight: '500',
                border: '1px solid #c7d2fe'
              }}>
                ✨ Referral applied! You'll receive your bonus after signup.
              </div>
            )}
            <p>Start your 14-day free trial. No credit card required.</p>
          </header>

          <form className="reg-form" onSubmit={handleSubmit}>
            <div className="row">
              <div className="input-group">
                <label>First Name *</label>
                <input 
                  type="text" name="firstName" className="reg-input" 
                  value={formData.firstName} onChange={handleChange} required 
                />
              </div>
              <div className="input-group">
                <label>Last Name *</label>
                <input 
                  type="text" name="lastName" className="reg-input" 
                  value={formData.lastName} onChange={handleChange} required 
                />
              </div>
            </div>

            <div className="input-group">
              <label>Work Email *</label>
              <input 
                type="email" name="email" className="reg-input" 
                value={formData.email} onChange={handleChange} required 
              />
            </div>

            <div className="input-group">
              <label>Company Name *</label>
              <input 
                type="text" name="companyName" className="reg-input" 
                value={formData.companyName} onChange={handleChange} required 
              />
            </div>

            <div className="input-group">
              <label>Create Password *</label>
              <input 
                type="password" 
                name="password" 
                className="reg-input" 
                value={formData.password} 
                onChange={handleChange} 
                required 
              />
              <div className="password-hints">
                <div className={`hint-item ${checks.minLength ? 'text-success' : ''}`}>
                  <span className="dot-hint"></span> At least 8 characters
                </div>
                <div className={`hint-item ${checks.hasUppercase ? 'text-success' : ''}`}>
                  <span className="dot-hint"></span> One uppercase letter
                </div>
                <div className={`hint-item ${checks.hasNumber ? 'text-success' : ''}`}>
                  <span className="dot-hint"></span> One number
                </div>
              </div>
            </div>

            <div className="input-group">
              <label>How did you hear about us?</label>
              <div className="select-wrapper w-100">
                <select 
                  name="source" className="reg-input select-custom form-select"
                  value={formData.source} onChange={handleChange}
                >
                  <option value="">Select an option</option>
                  <option value="google">Google Search</option>
                  <option value="social">Social Media</option>
                  <option value="referral">Friend/Colleague</option>
                </select>
                <LuChevronDown className="select-arrow" />
              </div>
            </div>

            <div className="checkbox-section">
              <label className="check-row">
                <input 
                  type="checkbox" name="agreeTerms" 
                  checked={formData.agreeTerms} onChange={handleChange} required 
                />
                <span className="check-text">
                  I agree to the <a href="/terms" target='_blank'>Terms of Service</a> and <a href="/privacy" target='_blank'>Privacy Policy</a> *
                </span>
              </label>
              <label className="check-row">
                <input 
                  type="checkbox" name="marketingEmails" 
                  checked={formData.marketingEmails} onChange={handleChange} 
                />
                <span className="check-text">Send me product updates, tips, and offers via email</span>
              </label>
            </div>

            <div className="reg-footer">
              <button type="button" className="btn-back" onClick={() => window.history.back()}>
                ← Back
              </button>
              <button type="submit" className="btn-continue">
                Continue to Plan Selection <LuChevronRight />
              </button>
            </div>
          </form>
        </div>
      </div>

      <footer className="auth-footer-dark">
        <div className="footer-links">
          <a href="/privacy" style={{color: "#fff"}}>Privacy Policy</a>
          <a href="/terms"  style={{color: "#fff"}}>Terms of Service</a>
          {/* <a href="#">Support</a> */}
          {/* <a href="#">Contact Us</a> */}
        </div>
        <div className="footer-copyright">
          © 2026 Measro LLC. All rights reserved.
        </div>
      </footer>
    </div>
  );
};

export default Register;